module.exports = __webpack_public_path__ + "img/book1.98c8f022.jpg";